import { initializeApp } from "firebase/app";
import { getToken, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import firebaseConfig from "../firebaseConfig.json";

if (process.env.NODE_ENV !== 'production') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true
});

export const getAppCheckToken = async () => {
  const res = await getToken(appCheck, true);
  return res?.token;
}